import React from "react";

import { useTheme } from "../../../context/theme";
import { TypographyBodySize } from "../../../styles/typography/typography";
import { ResponsiveDimension, ResponsiveProp } from "../../../types";
import { Box, Column, Columns } from "../../layout";
import { Text } from "../../typography";
import { logoDescriptions, LogoVariant, logoVariantMap } from "./consts";

type Props = {
  variant?: LogoVariant;
  text?: string;
  width?: ResponsiveProp<string>;
  height?: ResponsiveProp<string>;
  maxWidth?: ResponsiveProp<string>;
  maxHeight?: ResponsiveProp<string>;
  textSize?: TypographyBodySize;
  dividerSpacing?: ResponsiveDimension;
};
export default function Logo(props: Props) {
  const {
    variant = "default",
    text,
    textSize,
    width,
    height,
    dividerSpacing,
    maxWidth,
    maxHeight
  } = props;
  const theme = useTheme();

  const LogoVariant = logoVariantMap[variant];

  const { description: logoDescription } = logoDescriptions[variant];

  const FormattedLogo = (
    <LogoVariant
      color={theme["primary-high-content"]}
      aria-label={logoDescription}
      width={"auto"}
      height={height ?? "100%"}
      maxHeight={maxHeight}
    />
  );

  return (
    <Box
      width={width}
      height={height}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
    >
      {text ? (
        <LogoWithText
          logo={FormattedLogo}
          text={text}
          textSize={textSize}
          dividerHeight={height}
          dividerSpacing={dividerSpacing}
        />
      ) : (
        FormattedLogo
      )}
    </Box>
  );
}

type LogoWithTextProps = {
  logo: React.ReactNode;
  text: string;
  textSize?: TypographyBodySize;
  dividerHeight?: ResponsiveProp<string>;
  dividerSpacing?: ResponsiveDimension;
};
function LogoWithText({
  logo,
  text,
  textSize = "medium",
  dividerHeight,
  dividerSpacing = "large"
}: LogoWithTextProps) {
  return (
    <Columns alignY="center" space={dividerSpacing}>
      <Column width="content">{logo}</Column>
      <Column width="content">
        <LogoDivider height={dividerHeight} />
      </Column>
      <Column width="content">
        <Box textDecoration="none">
          <Text tone="primary" size={textSize} truncate>
            {text}
          </Text>
        </Box>
      </Column>
    </Columns>
  );
}

type LogoDividerProps = {
  height?: ResponsiveProp<string>;
};
function LogoDivider({ height = "auto" }: LogoDividerProps) {
  const theme = useTheme();
  return (
    <Box
      height={height}
      width="1px"
      display="flex"
      backgroundColor={theme["primary-high-content"]}
    />
  );
}
